

export const GET_PRODUCTS="GET_PRODUCTST"
export const GET_SINGLE_PRODUCT="GET_SINGLE_PRODUCTS"